import useTranslations from '@/i18n/useTranslations';
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import ImageCropper from "./ImageCropper";

import "./styles/PopupUpdateProfilePicture.css";

const PopupUpdateProfilePictureInSettings = ({ open, image, exitCrop, continueCrop, setCroppedFile, setCroppedUrl, cropShape }) => {
  const t = useTranslations('common.user_settings.edit_profile');
  // Define cropAreaClass inside the function
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';

  return (
    <GenericPopup
      open={open}
      className={`profile-picture__crop-popup ${cropAreaClass}`}
    >
      <div className="profile-picture__header">
        <p className="profile-picture__header-text">
          {t('crop_popup.title')}
        </p>
        <p className="profile-picture__instructions">
          {t('crop_popup.instructions')}
        </p>
      </div>
      <ImageCropper
        source={image}
        width={200}
        height={200}
        cropShape={cropShape}
        exitCrop={exitCrop}
        continueCrop={continueCrop}
        continueLabel={t('crop_popup.continue_button')}
        exitLabel={t('crop_popup.exit_button')}
        setCroppedUrl={setCroppedUrl}
        setCroppedFile={setCroppedFile}
      />
    </GenericPopup>
  );
};

export default PopupUpdateProfilePictureInSettings;
